import buildRace from './buildRace'
import buildRaceExeption from './buildRaceExeption'

export default (data) => {

  const r = {}
  r.data = data
  const raceCode = {
    race: "3",
    ranking: "T"
  }
  const init = () => {
    console.log('buildRaceFinal', r.data);

    buildFinalPanel();
    buildRankingMatchPanel();

    buildRaceExeption(raceCode, r.data.race);
  }

  const buildFinalPanel = () => {
    const roundListUl = document.getElementById('final');

    buildRace(roundListUl, r.data.race[raceCode.race], r.data.page);
  }
  const buildRankingMatchPanel = () => {
    const roundListUl = document.getElementById('ranking');

    buildRace(roundListUl, r.data.race[raceCode.ranking], r.data.page);
  }

  init();
}
